import { PlusCircle, XCircle } from 'lucide-react';
import { forwardRef } from 'react';

import { sharedComboBoxStyles } from '@/components/ui/inputs/combobox-multi/trigger';
import { VisuallyHidden } from '@/components/visually-hidden';

export interface StatusTriggerProps {
  selectedValue?: string;
  onTogglePopover: () => void;
  onValueChange: (value: string | undefined) => void;
  placeholder: string;
  className?: string;
  isOpen?: boolean;
}

const StatusTrigger = forwardRef<HTMLButtonElement, StatusTriggerProps>(
  ({ selectedValue, onTogglePopover, onValueChange, placeholder, className, isOpen }, ref) => {
    const { base, selectedValuesWrapper, content, icon } = sharedComboBoxStyles({
      hasItemsSelected: Boolean(selectedValue),
    });

    return (
      <div className="relative">
        <button
          type="button"
          ref={ref}
          onClick={onTogglePopover}
          className={base({ className })}
          aria-expanded={isOpen || Boolean(selectedValue)}
        >
          <div className={content()}>
            {placeholder ? <span>{placeholder}</span> : null}
            {selectedValue ? <div className={selectedValuesWrapper()}>{selectedValue}</div> : null}
          </div>
        </button>
        {selectedValue ? (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onValueChange(undefined);
            }}
            title="Clear filter"
            aria-label="Clear filter"
            className={icon({ className: 'hover:text-errorDark' })}
          >
            <XCircle className="size-4 min-w-4" />
            <VisuallyHidden>Clear filter</VisuallyHidden>
          </button>
        ) : (
          <PlusCircle className={icon({ className: 'pointer-events-none' })} />
        )}
      </div>
    );
  },
);

StatusTrigger.displayName = 'StatusTrigger';

export { StatusTrigger };
